export default __webpack_public_path__ + "static/media/lb-hackathon-level-2.c3f3dbf2.svg";